











































































































































































import { defineComponent } from "vue";
import RefundAttentionAdviser from "../RefundAttentionAdviser.vue";
import RefundInvoiceAdviser from "../RefundInvoiceAdviser.vue";
import RefundInvoiceAdviserDigital from "../RefundInvoiceAdviserDigital.vue";
import IconRow from "@/components/Atoms/icon-row.vue";

export default defineComponent({
  components: {
    RefundInvoiceAdviser,
    RefundAttentionAdviser,
    RefundInvoiceAdviserDigital,
    IconRow
  }
});
